import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { clearError, verifyMagicLink } from '../redux/slices/authSlice';
import AmbientBackground from '../components/AmbientBackground';

const MagicLoginPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { verifyingToken, error, isAuthenticated } = useAppSelector((state) => state.auth);
  const [hasStarted, setHasStarted] = useState(false);

  useEffect(() => {
    dispatch(clearError());
    const token = searchParams.get('link') ?? searchParams.get('token');
    if (token && !hasStarted) {
      setHasStarted(true);
      void dispatch(verifyMagicLink({ magicLinkToken: token })).unwrap();
    }
  }, [dispatch, hasStarted, searchParams]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="relative flex min-h-screen items-center justify-center px-4 text-white">
      <AmbientBackground />
      <div className="relative w-full max-w-md rounded-[2rem] border border-white/10 bg-white/10 p-8 text-center shadow-glow backdrop-blur-2xl">
        <div className="text-sm uppercase tracking-[0.3em] text-brand-200">Verifying</div>
        <h1 className="mt-4 text-2xl font-semibold">Signing you in</h1>
        <p className="mt-3 text-sm leading-6 text-white/70">
          {verifyingToken ? 'Checking your magic link now.' : 'If the link is valid, you will be redirected shortly.'}
        </p>
        {error ? <div className="mt-6 rounded-2xl bg-red-500/10 px-4 py-3 text-sm text-red-100">{error}</div> : null}
      </div>
    </div>
  );
};

export default MagicLoginPage;
